export interface LeadershipItem {
  period: string
  current: boolean
  title: string
  org: string
  details: string[]
  tags: string[]
}

export const LEADERSHIP: LeadershipItem[] = [
  {
    period: 'Feb 2023 — Present',
    current: true,
    title: 'Member',
    org: 'Young Political Leaders Community, FNF Tunisia',
    details: [
      'Engaged with a regional network focused on civic participation, democratic values and policy dialogue across the Mediterranean.',
      'Represented student perspectives in moderated discussions and workshops on governance, digital rights and youth leadership.',
    ],
    tags: ['Public Speaking', 'Policy Dialogue', 'Workshops'],
  },
  {
    period: 'Dec 2023 — Sep 2024',
    current: false,
    title: 'Technical Lead',
    org: 'Microsoft EPI Club, Sousse',
    details: [
      'Led the technical track of the club, designing workshops and hands-on sessions around cloud, DevOps and software engineering.',
      'Mentored members on projects, code reviews and modern development practices, growing the club\u2019s technical community.',
    ],
    tags: ['Mentoring', 'Workshops', 'Cloud'],
  },
  {
    period: 'Jan 2022 — May 2023',
    current: false,
    title: 'Co-Lead',
    org: 'Google Developer Student Clubs (GDSC), FSS Sfax',
    details: [
      'Co-led a student developer community spanning hundreds of members, planning events, hackathons and study groups.',
      'Organized hands-on sessions in web development, cloud basics and open-source contribution, boosting member engagement.',
    ],
    tags: ['Community', 'Events', 'Linux'],
  },
  {
    period: 'Dec 2021 — May 2022',
    current: false,
    title: 'Project Lead',
    org: 'IEEE FSS Student Branch, Sfax',
    details: [
      'Led a student project team end to end, from requirements and planning to implementation and demo delivery.',
      'Coordinated milestones across the team, presenting progress at branch-wide showcases and technical meetups.',
    ],
    tags: ['Project Management', 'Team Coordination', 'Presentations'],
  },
]